import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MiniWorldComponent, WorldEvent, CollectionEvent } from './mini-world.component';
import { LightImageModule } from '../light-image/light-image.module';
import { PassiveTouchModule, SwiperModule } from '../../directives';
import { ListMoteComponentModule } from '../list-mote/list-mote.module';
import { TruncatePipe, TruncatedPipe } from './truncate.pipe';
import { MotesMediaModule } from '../motes-media/motes-media.module';
import { MiniMoteComponentModule } from '../mini-mote/mini-mote.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

export { CollectionEvent, WorldEvent };

@NgModule({
    declarations: [MiniWorldComponent, TruncatePipe, TruncatedPipe],
    imports: [
        CommonModule,
        LightImageModule,
        PassiveTouchModule,
        ListMoteComponentModule,
        MotesMediaModule,
        SwiperModule,
        MiniMoteComponentModule,
        SvgIconModule
    ],
    exports: [MiniWorldComponent]
})
export class MiniWorldComponentModule { }
